/**
 * Small, dependency-free business-question helpers, extracted out of
 * WizardContext.jsx (answers-step batch, 2026-07-22) so lib/
 * answersValidation.js can use normalizeQuestion without creating a
 * circular import (WizardContext -> answersValidation for the resume-time
 * temporal check, answersValidation -> WizardContext for normalizeQuestion
 * would otherwise be a cycle). WizardContext.jsx re-exports both names
 * unchanged, so existing `import { normalizeQuestion } from './WizardContext'`
 * call sites are untouched.
 */

// business_questions items may be a plain string (legacy/user-added) or an
// object {question, answer_type, suggestions, is_mandatory, field_key}.
export const normalizeQuestion = (q) => {
  if (typeof q === 'string') {
    return { question: q, answer_type: 'text', suggestions: [], is_mandatory: false, field_key: null, default_value: null };
  }
  return {
    question: q?.question || '',
    answer_type: q?.answer_type || 'text',
    suggestions: q?.suggestions || [],
    is_mandatory: q?.is_mandatory || false,
    field_key: q?.field_key || null,
    default_value: q?.default_value || null,
  };
};

export const isAnswerEmpty = (value) => {
  if (value === undefined || value === null) return true;
  if (typeof value === 'string') return value.trim() === '';
  if (typeof value === 'object') return Object.keys(value).length === 0;
  return false;
};
